<template>
    <div>
        <v-tabs hide-slider>
            <v-tab
                v-for="op in options" :key="op.value"
                @click="option = op.value"
                class="tab-container"
                active-class="active-tab-container"
            >
                <v-icon v-text="op.icon"/>
                <span class="ml-1" v-if="op.value === option">
                {{ op.name }}
            </span>
            </v-tab>
        </v-tabs>
    </div>
</template>

<script>
export default {
    name: "SelectOptionStudents",
    props: {
        noList: {
            type: Boolean,
            default: false,
        },
        onlyGroups: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            option: null,
        }
    },
    computed: {
        options(vm = this) {
            let options = [
                {name: `${vm.$t('common.group')}s`, value: 'group', icon: 'mdi-account-multiple'},
                {name: `${vm.$t('common.team')}s`, value: 'team', icon: 'mdi-account-group'},
            ]
            if (vm.onlyGroups) return options
            options = [
                {name: vm.$t('common.list'), value: 'all', icon: 'mdi-group'},
                {name: `${vm.$t('common.student')}s`, value: 'student', icon: 'mdi-account'},
                ...options
            ]
            if (vm.noList) options = options.filter(option => option.value !== 'all')
            return options
        }
    },
    mounted() {
        const vm = this
        vm.option = vm.options[0].value
    },
    watch: {
        option(val) {
            this.$emit('change', val)
        }
    }
}
</script>

<style scoped>

.tab-container {
    background: #cbff99;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 0 6px 3px rgba(1, 55, 46, 0.1) !important;
    margin-left: 12px;
    margin-top: 12px;
    color: #7a7a7a;
    overflow: visible !important;
    text-transform: none;
}

.active-tab-container {
    background: #FFFFFF;
}

</style>